// extracted by mini-css-extract-plugin
export default {"toolbarAndSaveButton":"jUWWAgLaJB","toolbarDivider":"RuLgaQdN1o","richTextEditorToolbarContainer":"gg6eXH21hl","toolbar":"VxTp7G7YRC","inlineSelectorContainer":"B6cbd4z0aM"};